import { createReducer } from '@reduxjs/toolkit';

import * as linksActions from './linksActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  type: 'link',
  isActive: false,

  headingTitle: '',
  headingDescription: '',
  layout: 'list',
  items: [],
};

const links = createReducer(initialState, (builder) => {
  builder
    .addCase(linksActions.linksStore, (state, { payload: data }) => {
      const { blockId, uid, isActive, links: linksData } = data;
      const section = linksData ?? {};

      return {
        ...state,
        error: null,
        requesting: false,
        id: blockId ?? 0,
        uid: uid ?? 0,
        isActive: isActive,
        headingTitle: section.headingTitle ?? '',
        headingDescription: section.headingDescription ?? '',
        layout: section.layout ?? 'list',
        items: section.items ?? [],
      };
    })
    .addCase(linksActions.linksClear, () => ({ ...initialState }))

    .addCase(linksActions.linksUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(linksActions.linksUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(linksActions.linksUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(linksActions.linksUpdateHeadingTitle, (state, { payload }) => ({ ...state, headingTitle: payload }))
    .addCase(linksActions.linksUpdateHeadingDescription, (state, { payload }) => ({ ...state, headingDescription: payload }))
    .addCase(linksActions.linksUpdateLayout, (state, { payload }) => ({ ...state, layout: payload }))
    .addCase(linksActions.linksUpdateItems, (state, { payload }) => ({ ...state, items: payload }));
});

export default links;
